export const ROW_MAX_WIDTH = 980;
export const COLUMN_SPACING = 20;
export const ROUNDBOX_INNER_PADDING = 15;
